import React, { useRef, useState } from 'react';
import swiperDefault from '@/pages/home/assets/img/common/game-default.svg';
import uploadSvg from '@gp/assets/svg/upload.svg';
import GeneralImageNew from '@gp/components/GeneralImageNew';
import Upload, {
  FILE_TYPE,
  getFileTypeByKey,
  getMimeType,
  image,
  video,
} from '@gp/components/Upload';
import {
  UPLOAD_BUTTON_VISUAL_INFO_TIPS,
  UPLOAD_FOLDER_NAME_MAP,
} from '@gp/constants/const';
import useCos from '@gp/hooks/useCos';
import { useEditProjectDetailInfo } from '@gp/pages/Pipeline/ProjectDetails/GameDetail/components/TeamGameInformation/hooks/useInformation';
import CoverBox from '@gp/pages/Pipeline/ProjectDetails/components/CoverBox';
import RenameBox from '@gp/pages/Pipeline/ProjectDetails/components/RenameBox';
import { getBIDSTencentQCouldMassage } from '@gp/services/global';
import { getVideoCover } from '@gp/services/projectDetail';
import {
  reportBtnOperationLog,
  getFileSize,
  isValidNumber,
  splitFileName,
  getFileAndSuffixByFileName,
} from '@gp/utils/common';
import {
  useBoolean,
  useDebounceFn,
  useDeepCompareEffect,
  useMemoizedFn,
  useSetState,
} from 'ahooks';
import { cloneDeep, find, get, isEmpty, last, zip } from 'lodash-es';
import classnames from 'classnames';
import * as rbd from 'react-beautiful-dnd';
import {
  Button,
  Dropdown,
  Icon,
  Modal,
  Table,
  message,
  notification,
} from 'tea-component';
import { useIntl } from 'umi';
import { v4 as uid } from 'uuid';
import './index.scss';

const { draggable } = Table.addons;
const ACCEPTS = [...(video?.split(',') || []), ...(image?.split(',') || [])];

const uploadIconStyle: React.CSSProperties = {
  width: 16,
  height: 16,
  color: '#888',
  marginRight: 4,
  position: 'relative',
  top: -2,
  verticalAlign: 'middle',
};

const allowsUploadingCollections = video
  .split(',')
  .concat(image.split(','))
  .map((ext) => ext.trim().toLowerCase());
enum IUploadTypeError {
  SizeVideoError = 5 * 1024 * 1024 * 1024, // 视频
  SizeImgError = 500 * 1024 * 1024, // 图片
  SizeVideoDefault = '5GB',
  SizeImgDefault = '500MB',
}
const VisualEditForm = (props: any) => {
  const {
    closeVisual,
    visualCaseDataRefresh,
    gameInformationData,
    visualcaseData,
    // setIsEditLoading,
  } = props;
  const { formatMessage } = useIntl();

  const { deleteObject } = useCos({
    qCouldService: getBIDSTencentQCouldMassage,
    qCouldServiceParams: UPLOAD_FOLDER_NAME_MAP.visualFile,
  });
  // 编辑Api
  const { runAsync } = useEditProjectDetailInfo('VisualEdit');
  const [isEditLoading, setIsEditLoading] = useState(false);

  const { project_id, studio_entity_id } = gameInformationData || {};

  // 提交时，要删除的云文件
  const [deletePathList, setDeletePathList] = useState<any[]>([]);

  // const [segmentValue, setSegmentValue] = useState<string>('Pitch');
  // 枚举列表存储页签数据
  // const [segmentValueList, setSegmentValueList] = useSetState<{ [key in string]: any }>({});
  const [recordsList, setRecordsList] = useState([]);

  useDeepCompareEffect(() => {
    if (Array.isArray(visualcaseData?.list)) {
      setRecordsList(visualcaseData?.list);
      currentSegmentFileList.current = visualcaseData?.list;
    }
  }, [visualcaseData]);

  // 控制重命名,cover弹框
  const [isShowView, setIsShowView] = useSetState<{
    isShowRename: number | undefined;
    isShowCover: number | undefined;
  }>({
    isShowRename: undefined,
    isShowCover: undefined,
  });
  // 表格数据源
  const currentSegmentFileList: any = useRef([]);
  // 视频上传进度
  const [videoPercent, setVideoPercent] = useSetState<{}>({});
  // 拖拽节点
  // const dropRef = useRef(null);
  // 拖拽容器节点
  const containerFormRef = useRef(null);
  // const [isDropStyle, setisDropStyle] = useState(false);
  // 没上传完成不允许点击
  const [
    isDisabledBtn,
    { setTrue: setDisabledBtn, setFalse: setDisabledBtnFalse },
  ] = useBoolean(false);

  useDeepCompareEffect(() => {
    // 在非禁用情况下判断
    if (!isDisabledBtn) {
      // 进度是否全部100%
      const isAllComplete = Object.values(videoPercent).every(
        (value) => value === '100%',
      );

      // 如果有一个不是，
      if (!isAllComplete) {
        // 直接禁用
        setDisabledBtn();
      }
    }
  }, [videoPercent, isDisabledBtn]);

  //  上传开始前，时机在请求发出去前，先展示相关信息，而不是promise.all完在展示
  const onMultipleBeforeUploadFileMsg = (
    fileNames: any[],
    pathNames: any[],
    fileSizes: any[],
  ) => {
    setDisabledBtn();
    const fileName = fileNames.map((task: string) => {
      return task;
    });
    const fileSize = fileSizes.map((task: number) => {
      return getFileSize(task);
    });
    // 单个上传失败的处理
    const fileErrors = fileNames?.map((task, index) => ({
      fileTypeError: !allowsUploadingCollections.includes(
        `.${last(task.split('.'))}`.toLowerCase(),
      ),
      fileSizeError:
        fileSizes[index] >
        (getFileTypeByKey(FILE_TYPE, last(task.split('.')) || '') === 2
          ? IUploadTypeError.SizeVideoError
          : IUploadTypeError.SizeImgError),
    }));
    // 全部上传失败的处理,文件是有上传成功，但是在这个生命周期里面是截获不了数据的成功与否，如果全部失败，需要把按钮给放开，防止按钮一直禁用
    const fileErrorsAll = fileNames?.every((task, index) => {
      const fileTypeError = !allowsUploadingCollections.includes(
        `.${last(task.split('.'))}`.toLowerCase(),
      );
      const fileSizeError =
        fileSizes[index] >
        (getFileTypeByKey(FILE_TYPE, last(task.split('.')) || '') === 2
          ? IUploadTypeError.SizeVideoError
          : IUploadTypeError.SizeImgError);
      return fileTypeError || fileSizeError;
    });
    if (fileErrorsAll) {
      setDisabledBtnFalse();
    }
    let fileCoverImg;
    let fileCoverListImg;
    const ArrayFormKey = {
      fileName,
      fileSize,
      fileCoverImg,
      fileCoverListImg,
      // 做比较icon
      filePathNames: pathNames,
      // 是否有上传不符合要求的文件，
      fileErrors,
    };
    const dataList = zip(
      ArrayFormKey.fileName,
      ArrayFormKey.fileSize,
      ArrayFormKey.filePathNames,
      ArrayFormKey.fileErrors,
    ).map(([name, file_size, status, error]) => ({
      name,
      file_size,
      status,
      error,
    }));
    const lastList = [...dataList, ...recordsList];
    // const lastSegment = {
    //   [segmentValue]: [...dataList, ...(segmentValueList?.[segmentValue] || [])],
    // };
    currentSegmentFileList.current = lastList;

    setRecordsList(lastList);
  };

  // 单个上传处理成功回调
  const onMultipleSingleSuccess = async (
    dataSource: any,
    valueList: any,
    pathList: any,
  ) => {
    // debugger
    const fileType = pathList?.path?.split('.')?.pop();
    const isVideo = getFileTypeByKey(FILE_TYPE, fileType);

    const cover_list =
      isVideo === 2
        ? await getVideoCover({ path: pathList?.path, from: 'vs' })
        : [valueList?.url];
    setDisabledBtnFalse();
    // 克隆一遍
    const cloneDeepList = cloneDeep(currentSegmentFileList.current) || [];
    const indexKey = cloneDeepList.findIndex(
      (task: { status: any; }) => task.status === pathList?.path,
    );
    const item = cloneDeepList[indexKey] || {};
    (item.resource_cover = isVideo === 2 ? cover_list?.[0] : valueList?.url),
    (item.cover_list = cover_list),
    (item.resource_url = valueList?.url),
    (item.resource_id = uid()),
    (item.resource_type = isVideo);
    //  后来者需要注意，这里的删除，区分了上传中的删除以及完成后的删除，如果在下载过程进行删除操作，为防止indexKey 为-1，影响到最后一条数据，加个判断
    // 这里的流程主要是，先在upload组件中onMultipleBeforeUploadFileMsg周期里，初始化直接全部展示相关上传信息，如果不是想异步加载所有数据，而不是promise.all，流程是不会这么麻烦。
    // 上传中的删除只是前端ui删除，而没有进行接口中的cancel，最终会执行成功回调，之前删除的这条数据，会找不到，也就是会出现下标为-1的情况
    if (indexKey !== -1) {
      cloneDeepList.splice(indexKey, 1, item);
    }
    // 在重新赋值一遍修改过后的值
    currentSegmentFileList.current = cloneDeepList;
    setRecordsList(cloneDeepList);
    // setSegmentValueList({ [segmentValue]: cloneDeepList });
  };

  const deleteFileFun = async () => {
    const deFunList = deletePathList?.map((path: string) => {
      const uploadFolderName = path?.includes('/') ? path.split('/')[0] : '';
      return deleteObject({ path }, uploadFolderName);
    });
    Promise.all(deFunList).then(() => {});
  };

  // 操作删除
  const handleOnChangeDelete = (indexKey: number, cvm: any) => {
    if (cvm.cloud_path && cvm?.material_id < 1) {
      const newList = [...deletePathList, cvm.cloud_path];
      const deleteList = [...new Set(newList)];
      setDeletePathList(deleteList);
    }

    const cloneDeepFileList = cloneDeep(currentSegmentFileList.current) || [];
    const dataSource = cloneDeepFileList.filter(
      (task: any, index: number) => index !== indexKey,
    );
    currentSegmentFileList.current = dataSource;
    setRecordsList(dataSource);
  };
  // 操作重命名
  const handleOnChangeRenameValue = (
    text: string,
    indexKey: number,
    format: string,
  ) => {
    const cloneDeepFileList = cloneDeep(currentSegmentFileList.current) || [];
    if (!text) return;
    const fileNameNew = `${text ? text + (!!format ? `.${format}` : '') : ''}`;

    const dataSourceIndex = cloneDeepFileList.findIndex(
      (task: any, index: number) => index === indexKey,
    );
    cloneDeepFileList[dataSourceIndex].name = fileNameNew;
    currentSegmentFileList.current = cloneDeepFileList;
    setRecordsList(cloneDeepFileList);
    // setSegmentValueList({ [segmentValue]: cloneDeepFileList });
  };

  // 上传文件进度
  const onMultipleProgress = (res: string, path: number) => {
    let percent: number | string = path > 0.99 ? 0.99 : path;
    percent = `${(path * 100).toFixed(0)}%`;
    setVideoPercent({ [res]: percent });
  };

  // 确认回调
  const { run: handleOnSubmit } = useDebounceFn(
    async () => {
      try {
        setIsEditLoading(true);
        // 不允许上传错误类型的文件,最新文件
        const list = oneDimensionalArray(recordsList).filter(
          (task) => !task?.error?.fileTypeError && !task?.error?.fileSizeError,
        );

        // 如果发现没有改动，就不请求这次接口
        // if (isEmpty(getDiffSetParams)) {
        //   closeVisual();
        //   return;
        // }
        // 拿到入参，进行请求，关闭单框，出现成功提示
        const params = {
          project_id,
          studio_id: studio_entity_id,
          list,
        };
        await runAsync(params);
        visualCaseDataRefresh?.();
        // gameInformationDataRefresh?.();
        notification.success({
          description: 'Save success',
          duration: 1000,
        });
        closeVisual();

        if (Array.isArray(deletePathList) && deletePathList?.length > 0) {
          deleteFileFun();
        }
      } catch (error) {
        notification.error({
          description: 'Save failed. Please check the network',
          duration: 1000,
        });
      } finally {
        reportBtnOperationLog(
          'DETAIL_PROJECT_DETAIL_VISUAL_SHOWCASE_EDIT_SUBMIT',
        );
        setIsEditLoading(false);
      }
    },
    {
      wait: 300,
    },
  );

  // 替换封面
  const handleOnUploadCover = (
    cover: string,
    isChangeOneCover: boolean,
    indexKey: number,
  ) => {
    if (!cover) return;
    const cloneDeepFileList = cloneDeep(currentSegmentFileList.current) || [];

    const dataSourceIndex = cloneDeepFileList.findIndex(
      (task: any, index: number) => index === indexKey,
    );
    cloneDeepFileList[dataSourceIndex].resource_cover = cover;
    if (isChangeOneCover) {
      cloneDeepFileList[dataSourceIndex].cover_list[0] = cover;
    }

    currentSegmentFileList.current = cloneDeepFileList;
    setRecordsList(cloneDeepFileList);
    // setSegmentValueList({ [segmentValue]: cloneDeepFileList });
  };

  // 兼容历史数据，旧风格没有cover_list，上传到新风格会null
  const handleDropdownCoverUpload = async (cvm: any, indexKey: any) => {
    setIsShowView({
      isShowCover: indexKey,
    });
    // 如果是视频并且后端返回的cover_list 为空，需要重新调一遍接口，兼容旧数据
    if (cvm?.resource_type === 2 && isEmpty(cvm?.cover_list)) {
      const pathCloud = cvm?.cloud_path;
      const pathStrSpliceRes = pathCloud.includes('&&')
        ? pathCloud?.split('&&')?.[0]
        : pathCloud;
      const fromKey =
        !cvm?.material_id || cvm?.material_id === 0 ? 'vs' : 'material';
      const res = await getVideoCover({
        path: pathStrSpliceRes,
        from: fromKey,
      });
      setDisabledBtnFalse();
      const cloneDeepFileList = cloneDeep(currentSegmentFileList.current) || [];
      const dataSourceIndex = cloneDeepFileList.findIndex(
        (task: any, index: number) => index === indexKey,
      );
      cloneDeepFileList[dataSourceIndex].resource_cover = res[0];
      cloneDeepFileList[dataSourceIndex].cover_list = res;
      currentSegmentFileList.current = cloneDeepFileList;
      // setRecordsList(cloneDeepFileList);
      // setSegmentValueList({ [segmentValue]: cloneDeepFileList });
    }
  };

  const onDragEnd = useMemoizedFn((rec) => {
    setRecordsList(rec);
    currentSegmentFileList.current = rec;
  });

  return (
    <div className="dbg-visual-edit font14">
      <div className="dbg-visual-edit-upload">
        <div className="dbg-visual-edit-upload-button">
          <Upload
            isToLowerCase
            ref={containerFormRef}
            multiple
            accept={ACCEPTS}
            uploadFolderName={UPLOAD_FOLDER_NAME_MAP.visualFile}
            isVisualFile={true}
            getMimeType={getMimeType}
            limitedType={`${video},${image}`}
            id="video"
            onMultipleProgress={onMultipleProgress}
            onMultipleSingleSuccess={onMultipleSingleSuccess}
            onMultipleBeforeUploadFileMsg={onMultipleBeforeUploadFileMsg}
            // 上传成功需要把确认按钮解除禁用，单个上传失败的，已经处理过了，在BeforeUpload处理过了
            // onMultipleSuccess={setDisabledBtnFalse}
            // 这种情况基本不可能发生，但是还是兜底把，如果断网按钮也给放开
            onMultipleError={setDisabledBtnFalse}
            maxSize={5 * 1024 * 1024 * 1024}
            slot={
              <Button>
                <img style={uploadIconStyle} src={uploadSvg} />
                <span>Upload</span>
              </Button>
            }
            onSizeOver={() => {
              message.warning({
                content: 'The video size cannot exceed 5 GB',
              });
            }}
          ></Upload>
          <div className="dbg-gr-edit-upload-button-tips">
            {UPLOAD_BUTTON_VISUAL_INFO_TIPS}
          </div>
        </div>
        <div className="dbg-visual-edit-upload-content">
          <Table
            bordered={false}
            className="dbg-visual-edit-upload-table"
            records={recordsList}
            addons={[
              draggable({
                module: rbd,
                onDragEnd,
              }),
            ]}
            columns={[
              {
                key: 'filename',
                header: 'Filename',
                width: 350,
                render: (cvm) => {
                  const isError =
                    cvm?.error?.fileTypeError || cvm?.error?.fileSizeError;
                  const srcValue =
                    cvm?.resource_type === 1
                      ? cvm?.resource_url
                      : cvm?.resource_cover || cvm?.resource_url;
                  return (
                    <>
                      <div className="dbg-visual-info">
                        <div className="dbg-visual-info-avatar">
                          {cvm?.resource_cover ||
                          cvm?.resource_url ||
                          isError ? (
                              <GeneralImageNew
                                className={`update-user-item-cover`}
                                width={37}
                                height={24}
                                src={isError ? swiperDefault : srcValue}
                                errorImg={swiperDefault}
                              />
                            ) : (
                              <Icon
                                type="loading"
                                className={`update-user-item-cover`}
                              />
                            )}
                        </div>
                        <div className="dbg-visual-info-name">
                          {cvm?.name || '-'}
                        </div>
                      </div>
                    </>
                  );
                },
              },
              {
                key: 'size',
                header: 'Size',
                width: 100,
                render: (cvm) => {
                  return (
                    <>
                      <div className="dbg-visual-size">
                        {cvm?.file_size || '-'}
                      </div>
                    </>
                  );
                },
              },
              {
                key: 'status',
                header: 'Status',
                width: 250,
                render: (cvm, list, index) => {
                  const isError =
                    cvm?.error?.fileTypeError || cvm?.error?.fileSizeError;
                  return (
                    <>
                      <div className="dbg-visual-status">
                        <div className="dbg-visual-status-text">
                          <Icon
                            type={
                              cvm?.resource_id ||
                              videoPercent?.[cvm?.status] === '100%'
                                ? 'success'
                                : isError
                                  ? 'error'
                                  : 'loading'
                            }
                          />
                          <span>
                            {cvm?.resource_id ||
                            videoPercent?.[cvm?.status] === '100%'
                              ? 'Upload complete'
                              : isError
                                ? cvm?.error?.fileTypeError
                                  ? 'File type not supported'
                                  : `File exceeds  ${
                                    cvm?.resource_type === 1
                                      ? IUploadTypeError.SizeImgDefault
                                      : IUploadTypeError.SizeVideoDefault
                                  }limit`
                                : `Uploading: ${
                                  videoPercent?.[cvm?.status] || '0%'
                                } complete`}
                          </span>
                        </div>
                      </div>
                    </>
                  );
                },
              },
              {
                key: 'Action',
                header: 'Actions',
                render: (cvm, list, index) => {
                  const { uniqueId, path, name, status, progress } = cvm || {};
                  const { name: fileName, format } =
                    getFileAndSuffixByFileName(name);
                  return (
                    <>
                      <div className="dbg-visual-operation">
                        {/* 禁用态：disabled */}
                        <div
                          // ref={feedbackRef}
                          className={`dbg-visual-operation-item ${
                            cvm?.resource_id
                              ? ''
                              : videoPercent?.[cvm?.status] !== '100%'
                              ? 'disabled'
                              : ''
                          }`}
                        >
                          {
                            <Dropdown
                              button="Rename"
                              appearance="pure"
                              clickClose={false}
                              placement="bottom-end"
                              onOpen={() =>
                                setIsShowView({
                                  isShowRename: index,
                                })
                              }
                              open={isShowView.isShowRename === index}
                              onClose={() =>
                                setIsShowView({
                                  isShowRename: undefined,
                                })
                              }
                            >
                              <RenameBox
                                {...{
                                  value: fileName,
                                  handleOnChangeRenameValue: (text: any) =>
                                    handleOnChangeRenameValue(
                                      text,
                                      index,
                                      format,
                                    ),
                                  handleChangeModalCancel: () =>
                                    setIsShowView({
                                      isShowRename: undefined,
                                    }),
                                }}
                              />
                            </Dropdown>
                          }
                        </div>
                        {cvm?.resource_type === 2 && (
                          <div className="dbg-visual-operation-item">
                            <Dropdown
                              boxClassName="dbg-visual-operation-dropdown"
                              onOpen={() =>
                                handleDropdownCoverUpload(cvm, index)
                              }
                              onClose={() =>
                                setIsShowView({
                                  isShowCover: undefined,
                                })
                              }
                              button="Cover"
                              appearance="pure"
                              clickClose={false}
                              placement="bottom-end"
                              open={isShowView.isShowCover === index}
                            >
                              <CoverBox
                                {...{
                                  resource_cover: cvm?.resource_cover,
                                  cover_list: cvm?.cover_list || [],
                                  handleOnUploadCover: (
                                    valueCover: any,
                                    isChangeOneCover: boolean,
                                  ) =>
                                    handleOnUploadCover(
                                      valueCover,
                                      isChangeOneCover,
                                      index,
                                    ),
                                  handleChangeModalCancel: () =>
                                    setIsShowView({
                                      isShowCover: undefined,
                                    }),
                                  setDisabledBtn,
                                  isDisabledBtn,
                                  setDisabledBtnFalse,
                                }}
                              />
                            </Dropdown>
                          </div>
                        )}
                        <div
                          className={classnames(
                            'dbg-visual-operation-item dbg-visual-operation-item--del-btn',
                            {
                              disabled:
                                !cvm?.resource_id &&
                                videoPercent?.[cvm?.status] !== '100%',
                            },
                          )}
                          onClick={() => handleOnChangeDelete(index, cvm)}
                        >
                          Delete
                        </div>
                      </div>
                    </>
                  );
                },
              },
            ]}
          ></Table>

          {isEmpty(recordsList) && (
            <Upload
              isToLowerCase
              isOpenDropUpload
              ref={containerFormRef}
              multiple
              accept={ACCEPTS}
              uploadFolderName={UPLOAD_FOLDER_NAME_MAP.visualFile}
              isVisualFile={true}
              getMimeType={getMimeType}
              limitedType={`${video},${image}`}
              id="video2"
              onMultipleProgress={onMultipleProgress}
              onMultipleSingleSuccess={onMultipleSingleSuccess}
              onMultipleBeforeUploadFileMsg={onMultipleBeforeUploadFileMsg}
              // 上传成功需要把确认按钮解除禁用，单个上传失败的，已经处理过了，在BeforeUpload处理过了
              // onMultipleSuccess={setDisabledBtnFalse}
              // 这种情况基本不可能发生，但是还是兜底把，如果断网按钮也给放开
              onMultipleError={setDisabledBtnFalse}
              slot={
                <div className="dgb-visual-edit-upload-nodata">
                  <p>
                    Click the "Upload" button at the top or drag the file to
                    this area
                  </p>
                </div>
              }
              onSizeOver={() => {
                message.warning({
                  content: 'The video size cannot exceed 5 GB',
                });
              }}
            />
          )}
        </div>
      </div>
      <Modal.Footer>
        <Button
          type="primary"
          onClick={handleOnSubmit}
          disabled={isDisabledBtn}
          loading={isEditLoading}
        >
          {formatMessage({ id: 'dbg_confirm' })}
        </Button>
        <Button
          type="weak"
          onClick={() => {
            closeVisual?.();
            // setSegmentValueList({});
            setRecordsList([]);
          }}
        >
          {formatMessage({ id: 'dbg_cancel' })}
        </Button>
      </Modal.Footer>
    </div>
  );
};
export default VisualEditForm;

// 针对每一项对象，进行遍历，组转一维数组
const oneDimensionalArray = (list: any) => {
  const cloneDeepList = cloneDeep(list);
  if (cloneDeepList?.length > 0) {
    // 对每个非空数组，映射其元素为新的对象，并包含milestone和name属性
    const newList = cloneDeepList.map((item: any, index: any) => {
      return {
        ...item,
        // milestone: get(find(segmentOptions, { value: index }), 'milestone', 4),
        indexNumber: index,
        name: item.name, // 使用当前元素的name属性
        // 如果需要其他属性，也可以在这里添加
        resource_url: item?.resource_url,
        resource_id: item?.resource_id,
        resource_type: item?.resource_type,
        cloud_path: item?.cloud_path || item?.status,
        resource_cover: item?.resource_cover,
        file_size: item?.file_size,
        cover_list: item?.cover_list,
        error: item?.error,
      };
    });
    return newList;
  }
  return [];
};

const getFileSize = (v: number) => {
  if (!v) return '';
  const g = Math.round(v / (1024 * 1024 * 1024));
  const m = Math.round(v / (1024 * 1024));
  const k = Math.round(v / 1024);
  if (g > 1) return `${g}GB`;
  if (m > 1) return `${m}MB`;
  return `${k}KB`;
};
